/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function syncMobileSubmenu(sliderule) {
    const trigger = sliderule.querySelector(`[data-sliderule-open="${sliderule.id}"]`);
    const panel = sliderule.querySelector('[data-sliderule]');
    const pane = trigger ? trigger.closest('[data-sliderule-pane]') : null;

    if (!trigger || !panel || !pane) return;

    const paneLevel = parseInt(pane.getAttribute('data-sliderule-pane') || '0', 10);
    const isExpanded = panel.classList.contains('is-visible') && paneLevel > 0;

    trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }

  function updateMobileMenuHeights(drawer) {
    drawer.querySelectorAll('[data-mobile-menu-block]').forEach((block) => {
      const visiblePanel =
        block.querySelector('[data-sliderule="2"].is-visible') ||
        block.querySelector('[data-sliderule="1"].is-visible');
      const linksContainer = visiblePanel
        ? visiblePanel.querySelector('[data-links]')
        : block.querySelector('[data-links]');
      const heightSource = linksContainer || block;

      block.style.setProperty('--block-height', `${heightSource.scrollHeight}px`);
    });
  }

  function syncAllMobileSubmenus(drawer) {
    drawer.querySelectorAll('mobile-sliderule').forEach((sliderule) => {
      syncMobileSubmenu(sliderule);
    });
  }

  function resetMobileMenuState(drawer) {
    drawer.querySelectorAll('[data-sliderule-pane]').forEach((pane) => {
      pane.setAttribute('data-sliderule-pane', '0');
    });

    drawer.querySelectorAll('[data-sliderule]').forEach((panel) => {
      panel.classList.remove('is-visible', 'is-hiding');
    });

    drawer.querySelectorAll('[data-animates]').forEach((item) => {
      item.classList.remove('is-visible', 'is-hidden', 'is-hiding');
    });

    syncAllMobileSubmenus(drawer);

    requestAnimationFrame(() => {
      updateMobileMenuHeights(drawer);
    });
  }

  function initMobileMenuSync() {
    const drawer = document.querySelector('header-drawer[data-drawer]');
    const button = document.querySelector('[data-drawer-toggle="hamburger"]');

    if (!drawer || !button) return;

    if (drawer.id) {
      button.setAttribute('aria-controls', drawer.id);

      const closeButton = drawer.querySelector('[data-drawer-close]');
      if (closeButton) {
        closeButton.setAttribute('aria-controls', drawer.id);
      }
    }

    drawer.addEventListener('theme:drawer:open', () => {
      button.setAttribute('aria-expanded', 'true');
      resetMobileMenuState(drawer);
    });

    drawer.addEventListener('theme:drawer:close', () => {
      button.setAttribute('aria-expanded', 'false');
      syncAllMobileSubmenus(drawer);
    });

    drawer.querySelectorAll('mobile-sliderule').forEach((sliderule) => {
      const trigger = sliderule.querySelector(`[data-sliderule-open="${sliderule.id}"]`);
      const pane = trigger ? trigger.closest('[data-sliderule-pane]') : null;
      const panel = sliderule.querySelector('[data-sliderule]');

      if (!trigger || !pane || !panel) return;

      const observer = new MutationObserver(() => {
        syncMobileSubmenu(sliderule);
        updateMobileMenuHeights(drawer);
      });

      observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
      observer.observe(pane, { attributes: true, attributeFilter: ['data-sliderule-pane'] });

      syncMobileSubmenu(sliderule);
    });

    requestAnimationFrame(() => {
      updateMobileMenuHeights(drawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuSync, { once: true });
  } else {
    initMobileMenuSync();
  }


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
